import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import {
  Button,
  Tabs, Tab
} from '@one-thd/sui-atomic-components';
import { WallAreaCalculator } from '@thd-olt-component-react/calculator';
import {
  Col, Image, Heading
} from '@thd-olt-component-react/core-ui';
import { EasyEstimator } from './EasyEstimator/EasyEstimator';
import paintModals from '../../../data/paint-modals';
import styles from './ContainerSize.module.scss';

const { calculateSize } = paintModals;
const cx = classNames.bind(styles);
const tabLabels = ['Paint Calculator', 'Easy Estimator'];

export const ContainerSize = () => {
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('containerSize.ready');
  }, []);
  const [index, setIndex] = useState(0);

  const handleTabChange = () => {
    setIndex(1);
  };

  const handleToggle = (event, newValue) => {
    setIndex(newValue);
  };

  const introPane = (
    <div className={cx('calculate-size-container')}>
      <Image
        className={cx('bucket-image')}
        src="https://assets.thdstatic.com/images/v1/paint/1-gallon-bucket.svg"
        alt="One Gallon Paint Bucket"
      />
      <div className={cx('instructions')}>
        Enter your room&apos;s measurements to get your results or check out the&nbsp;
        <Button
          variant="text"
          onClick={handleTabChange}
          className={cx('easy-estimate-link')}
        >
          Easy Estimator
        </Button>&nbsp;for a more
        general estimate.
      </div>
    </div>
  );

  const errorMessage = 'One or more fields have invalid input(s). Unable to calculate.';

  return (
    <div className={cx('container-size', 'sui-px-2')} data-component="PaintModalContentContainerSize">
      <Heading
        title="Calculate or Estimate"
        className={cx('container-size__heading')}
      />
      <Tabs value={index} onChange={handleToggle} variant="fullWidth">
        {tabLabels.map((label, labelIndex) => {
          return (
            <Tab
              key={labelIndex}
              label={label}
            />
          );
        })}
      </Tabs>
      {index === 0 && (
        <Col>
          <WallAreaCalculator
            errorMessage={errorMessage}
            introPane={introPane}
            disclaimer={calculateSize.disclaimer}
          />
        </Col>
      )}
      {index === 1 && (
        <Col>
          <EasyEstimator />
        </Col>
      )}
    </div>
  );
};

ContainerSize.displayName = 'ContainerSize';